import timg1 from '../images/team/1.jpg'
import timg2 from '../images/team/2.jpg'
import timg3 from '../images/team/3.jpg'
import timg4 from '../images/team/4.jpg'

import tSimg1 from '../images/team/single/img-1.jpg'
import tSimg2 from '../images/team/single/img-2.jpg'
import tSimg3 from '../images/team/single/img-3.jpg'
import tSimg4 from '../images/team/single/img-4.jpg'


const Teams = [
    {
        Id: '1',
        tImg:timg1,
        tSImg:tSimg1,
        slug:'Esther-Howard',
        name:'Esther Howard',
        title:'Councilor, District 3',
    },
    {
        Id: '2',
        tImg:timg2,
        tSImg:tSimg2,
        slug:'Guy-Hawkins',
        name:'Guy Hawkins',
        title:'Marketing Coordinator',
    },
    {
        Id: '3',
        tImg:timg3,
        tSImg:tSimg3,
        slug:'Robert-Fox',
        name:'Robert Fox',
        title:'Medical Assistant',
    },
    {
        Id: '4',
        tImg:timg4,
        tSImg:tSimg4,
        slug:'Devon-Lane',
        name:'Devon Lane',
        title:'President of Sales',
    }
]

export default Teams;